import * as signalR from '@microsoft/signalr';
import secureLocalStorage from 'react-secure-storage';

let connection: signalR.HubConnection | null = null;

export interface SessionTerminatedData {
  codigo: string;
  mensagem: string;
  timestamp: string;
}

export function createSignalRConnection(
  onSessionTerminated: (data: SessionTerminatedData) => void
): signalR.HubConnection {
  const hubUrl = process.env.REACT_APP_SIGNALR_URL || '';

  console.log('[SignalR] Criando conexão com:', hubUrl);

  connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => {
        const token = secureLocalStorage.getItem('@token') as string;
        console.log('[SignalR] Token presente:', !!token);
        return token || '';
      },
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connection.on('SessionTerminated', (data) => {
    console.log('[SignalR] Evento SessionTerminated recebido:', data);
    onSessionTerminated(data);
  });

  connection.onclose((error) => {
    console.log('[SignalR] Conexão fechada', error ? `Erro: ${error}` : '');
  });

  connection.onreconnecting((error) => {
    console.log('[SignalR] Reconectando...', error ? `Erro: ${error}` : '');
  });

  connection.onreconnected((connectionId) => {
    console.log('[SignalR] Reconectado com ID:', connectionId);
  });

  return connection;
}

export async function startConnection(): Promise<void> {
  if (connection && connection.state === signalR.HubConnectionState.Disconnected) {
    try {
      console.log('[SignalR] Iniciando conexão...');
      await connection.start();
      console.log('[SignalR] Conectado! Estado:', connection.state);
    } catch (error) {
      console.error('[SignalR] Erro ao conectar:', error);
      throw error;
    }
  } else {
    console.log('[SignalR] Conexão já existe ou não está desconectada. Estado:', connection?.state);
  }
}

export async function stopConnection(): Promise<void> {
  if (connection) {
    console.log('[SignalR] Parando conexão. Estado atual:', connection.state);
    if (connection.state === signalR.HubConnectionState.Connected) {
      await connection.stop();
      console.log('[SignalR] Conexão parada');
    }
  }
  connection = null;
}

export function getConnectionState(): signalR.HubConnectionState | null {
  return connection?.state ?? null;
}
